import React, { useState } from "react";
import img1 from "../../assets/Landing/img1.png";
import img2 from "../../assets/Landing/img2.png";
import img3 from "../../assets/Landing/img3.png";
import img4 from "../../assets/Landing/img4.png";

const Service = () => {
  const [flippedIndex, setFlippedIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setFlippedIndex(index);
  };

  const handleMouseLeave = () => {
    setFlippedIndex(null);
  };

  const cards = [ 
    {
      title: "0% Commission",
      description:
        "Make your business profitable without having to pay any commission on all the Naayatrade exclusive verticals.",
        imageSrc: img1,
    },
    {
      title: "Low Cost of Doing Business",
      description:
        "We provide free membership to all our traders, with multiple benefits and offers.",
      imageSrc: img2,
    },
    {
      title: "Enhanced Visibility",
      description:
        "Naayatrade ensures top-notch security measures to protect your data and transactions.",
        imageSrc: img3,
    },
    {
      title: "Ease of doing business",
      description:
        "Our team is available around the clock to assist you with any queries or issues.",
      imageSrc: img4,
    },
  ];
   
  


  return (
    <>
    <div style={{ width: "1440px", height: "550px", margin: "auto" }}>
      <div
        style={{
          width: "1440px",
          height: "80px",
          marginTop: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "267px",
            height: "30px",
            color: "#FF6300",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Why choose Naayatrade?
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: "40px",
        }}
      >
        {cards.map((card, index) => (
          <div
            key={index}
            style={{
              width: "295px",
              height: "385px",
              perspective: "1000px",
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                transformStyle: "preserve-3d",
                transition: "transform 0.6s",
                transform:
                  flippedIndex === index ? "rotateY(180deg)" : "rotateY(0deg)",
              }}
            >
              {/* Front Side */}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  backfaceVisibility: "hidden",
                  backgroundColor: "white",
                  borderRadius: "20px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={card.imageSrc} />
                <div
                  style={{
                    color: "#242424",
                    fontSize: "18px",
                    fontWeight: "600",
                   marginTop: "54px",
                  }}
                >
                  {card.title}
                </div>
                <div
                  style={{
                    color: "#484848",
                    fontSize: "14px",
                    textAlign: "center",
                    marginTop: "16px",
                    padding: "0 16px",
                  }}
                ></div>
              </div>

              {/* Back Side */}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  backfaceVisibility: "hidden",
                  backgroundColor: "#FBDFAA",
                  borderRadius: "20px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: "rotateY(180deg)",
                }}
              >
                <div
                  style={{
                    color: "black",
                    fontSize: "20px",
                    fontWeight: "600",
                    marginTop: "24px",
                  }}
                >
                  {card.title}
                </div>
                <div
                  style={{
                    color: "black",
                    fontSize: "16px",
                    textAlign: "center",
                    marginTop: "16px",
                    padding: "0 16px",
                  }}
                >
                  {card.description}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Service;
